import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { Route, Routes } from 'react-router-dom';

import './config/firebase';

import { ROUTES } from './constant/constants';
import AuthProvider from './context/AuthProvider';
import Login from './screen/Auth/Login';
import BannerImage from './screen/BannerImage/BannerImage';
import PromotionalBanner from './screen/PromotionalBanner/PromotionalBanner';
import Catalogue from './screen/Catalogue/Catalogue';
import ProductCategory from './screen/Category/ProductCategory';
import Home from './screen/Home';
import Order from './screen/Order';
import PageNotFound from './screen/PageNotFound';
import PrivacyPolicy from './screen/PrivacyPolicy/PrivacyPolicy';
import Product from './screen/Product';
import Report from './screen/Report';
import SparePart from './screen/SparePart';
import TermsAndCondition from './screen/TermsAndCondition/TermsAndCondition';
import Users from './screen/Users';
import ClientProtectedRoute from './utils/ClientProtectedRoutes';

function App() {
  // useEffect(() => {
  //   document.addEventListener('contextmenu', (event) => event.preventDefault());
  //   document.addEventListener('keydown', (event) => {
  //     if (
  //       (event.ctrlKey && event.shiftKey && event.key === 'I') || // Ctrl+Shift+I (Inspect Element)
  //       (event.ctrlKey && event.shiftKey && event.key === 'C') || // Ctrl+Shift+C (Inspect Element in Console)
  //       (event.ctrlKey && event.shiftKey && event.key === 'J') || // Ctrl+Shift+J (Open DevTools)
  //       (event.ctrlKey && event.key === 'U') || // Ctrl+U (View Page Source)
  //       (event.ctrlKey && event.key === 'S') || // Ctrl+S (Save page as)
  //       event.key === 'F12' // F12 (Open DevTools)
  //     ) {
  //       event.preventDefault();
  //     }
  //     function detectDevTools() {
  //       const element = new Image();
  //       Object.defineProperty(element, 'id', {
  //         get: function () {
  //           alert('Developer tools detected!');
  //           window.location = 'about:blank';
  //         },
  //       });
  //       console.log(element);
  //     }

  //     setInterval(detectDevTools, 1000);
  //   });
  // }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#394756',
          colorBgLayout: 'var(--color-bg)',
          colorBgContainer: 'var(--color-surface)',
          colorBorder: 'var(--color-border)',
          colorText: 'var(--color-text)',
          fontFamily: 'var(--font-sans)',
          borderRadius: 10,
        },
      }}
    >
      <AuthProvider>
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={
              <ClientProtectedRoute>
                <Home />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.CATALOGUE}
            element={
              <ClientProtectedRoute>
                <Catalogue />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.SPARE_PART}
            element={
              <ClientProtectedRoute>
                <SparePart />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.USERS}
            element={
              <ClientProtectedRoute>
                <Users />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRODUCT}
            element={
              <ClientProtectedRoute>
                <Product />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ORDER}
            element={
              <ClientProtectedRoute>
                <Order />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.REPORT}
            element={
              <ClientProtectedRoute>
                <Report />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRIVACY_POLICY}
            element={
              <ClientProtectedRoute>
                <PrivacyPolicy />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.TERMS_AND_CONDITION}
            element={
              <ClientProtectedRoute>
                <TermsAndCondition />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.LOGIN}
            element={<Login />}
          />
          <Route
            path={ROUTES.PRODUCT_CATEGORY}
            element={
              <ClientProtectedRoute>
                <ProductCategory />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.BANNER_IMAGE}
            element={
              <ClientProtectedRoute>
                <BannerImage />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PROMOTIONAL_BANNER}
            element={
              <ClientProtectedRoute>
                <PromotionalBanner />
              </ClientProtectedRoute>
            }
          />
          <Route
            path={ROUTES.NOT_FOUND}
            element={<PageNotFound />}
          />
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
